/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Canvas_Domain_Checked_LiveInputs */



/**
* | output |
* | --- |
* | "The domain is live." |
*
* @param {Canvas_Domain_Checked_LiveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const canvas_domain_checked_live = /** @type {((inputs?: Canvas_Domain_Checked_LiveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Canvas_Domain_Checked_LiveInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Domain ist online.")
	return /** @type {LocalizedString} */ ("The domain is live.")
});